// extracted by mini-css-extract-plugin
module.exports = {"linkLang":"LocaleSelector_linkLang__kxLpt","linkLang__active":"LocaleSelector_linkLang__active___L7X0"};